import React from "react";

function Footer() {
  const VersionString = import.meta.env.VITE_VERSION;

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "20px",
        justifyContent: "space-between",
      }}
    >
      <div style={{ fontSize: "14px", color: "#808080", fontWeight: "100" }}>
        © 聯新神經醫學中心2023
      </div>
      <div style={{ fontSize: "14px", color: "#808080", fontWeight: "100" }}>
        {VersionString}
      </div>
    </div>
  );
}

export default Footer;
